import { createAsyncActionConstants } from 'utilities/util';

export const TYPES = {
    FETCH_CBL: createAsyncActionConstants('FETCH_CBL'),
    FETCH_CBL_DETAILS: createAsyncActionConstants('FETCH_CBL_DETAILS'),
    SEARCH_CBL: createAsyncActionConstants('SEACH_CBL'),
    RESET_CBL: createAsyncActionConstants('RESET_CBL'),
    CBL_DETAILS: createAsyncActionConstants('CBL_DETAILS'),
    RESET_CBL_DETAILS: 'RESET_CBL_DETAILS',
}